import { cubicEaseOut } from '@helpers/animate';
import brand from '@helpers/brand';
import { Layers } from '@helpers/layers';
import { Device, until, from } from '@helpers/media';
import SimpleImage from '@stories/Components/SimpleImage/SimpleImage';
import { rgba } from 'polished';
import styled, { createGlobalStyle } from 'styled-components';
import DesktopNavigationStyles from './DesktopNavigation/DesktopNavigation.styles';
import TopLinksStyles from './TopLinks/TopLinks.styles';
const GlobalStyles = createGlobalStyle `
  /* Declare global header CSS variables. */
  :root {
    --topLinksHeight: 40px;
    --headerContainerHeight: 78px;
    --headerHeight: calc(var(--topLinksHeight) + var(--headerContainerHeight));
    --logoHeight: 54px;

    @media ${until(Device.TabletLarge)} {
      --headerContainerHeight: 80px;
      --headerHeight: 80px;
      --logoHeight: 42px;
    }

    scroll-padding-top: calc(var(--headerHeight) - 2px);
  }

  /* Ensure all body content is below fixed header. */
  #main {
    padding-top: var(--headerHeight);
  }

  /* Define attribute to allow header overlap. */
  [data-header-overlap="true"] {
    margin-top: calc(var(--headerHeight) * -1);
  }
`;
/**
 * Just used to declare CSS variables for the rest of the components.
 */
const Root = styled.div `
  --fgColor: ${brand.white};
  --bgColor: ${rgba(brand.white, 0)};
`;
const Container = styled.header `
  position: fixed;
  top: 0;
  left: 0;
  display: grid;
  background-color: var(--bgColor);
  color: var(--fgColor);
  height: var(--headerHeight);
  transition: background-color 0.15s ${cubicEaseOut}, color 0.15s ${cubicEaseOut};
  width: 100%;
  z-index: ${Layers.Header + 1};
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.08);

  ${TopLinksStyles.Container} {
    @media ${until(Device.TabletLarge)} {
      display: none;
    }
  }

  ${DesktopNavigationStyles.Container} {
    @media ${until(Device.TabletLarge)} {
      display: none;
    }
  }
`;
const Inner = styled.div `
  position: relative;
  display: flex;
  top: 0;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  width: 100%;
  height: var(--headerContainerHeight);
  padding: 0 18px;
  background: ${brand.white};

  @media ${from(Device.TabletLarge)} {
    top: var(--topLinksHeight);
  }

  @media ${from(Device.DesktopLarge)} {
    padding: 0 36px;
  }
`;
const LogoWrapper = styled.a `
  user-select: none;
  height: var(--logoHeight);

  &:focus {
    outline: 2px solid ${brand.blue.blue5};
    outline-offset: 5px;
  }
`;
const Logo = styled(SimpleImage) `
  opacity: 1;
  object-fit: cover;
  height: var(--logoHeight);
`;
const HeaderStyles = {
    Container,
    GlobalStyles,
    Inner,
    Logo,
    LogoWrapper,
    Root,
};
export default HeaderStyles;
